// extracted by mini-css-extract-plugin
module.exports = {"labelChecked":"CheckBoxForm_labelChecked__2qS9s"};